// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-03-12 15:35:24 +0100 (Wed, 12 Mar 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 150889 $
//  Purpose   : fulltext parts
// =============================================================================
import React from 'react'

import {loadLazy as ll, funcPart} from 'uix/parts'

export const EngineReports = ll(() => import(/* webpackChunkName: 'fulltext' */ './engines'))

export const PassageViewer = ll(() => import(/* webpackChunkName: 'fulltext' */ './passages'))
export const OcrDashboard = ll(() => import(/* webpackChunkName: 'fulltext' */ './dashboard'))
export const TextlabConfig = ll(() => import(/* webpackChunkName: 'fulltext' */ './config'))
export const LayoutControl = ll(() => import(/* webpackChunkName: 'fulltext' */ './LayoutControl'))

const _OcrInfoList = ll(() => import(/* webpackChunkName: 'fulltext' */ './list'))
export const OcrInfoList = funcPart({getGraphics: ['types']}, props => <_OcrInfoList {...props} />)

const _FulltextView = ll(() => import(/* webpackChunkName: 'fulltext' */ './recognition'))
export const FulltextView = funcPart({partStyle: {overflowX: 'hidden'}}, props => (
  <_FulltextView {...props} />
))

const _NamedEntities = ll(() => import(/* webpackChunkName: 'fulltext' */ './entities'))
export const NamedEntities = funcPart({partStyle: {overflowX: 'hidden'}}, props => (
  <_NamedEntities {...props} />
))

export const _CompareEngineTests = ll(() => import(/* webpackChunkName: 'fulltext' */ './compare'))
export const CompareEngineTests = funcPart({partStyle: {overflowX: 'hidden'}}, props => (
  <_CompareEngineTests {...props} />
))
